import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { BRAND } from '../../config/brands';
import { sendReset } from '../../data/authActions';

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [resetMsg, setResetMsg] = useState('');

  async function handleForgot() {
    if (!email.trim()) { setError('Enter your email above first, then tap "Forgot password?".'); return; }
    try { await sendReset(email.trim()); } catch { /* swallow — neutral message below */ }
    setResetMsg('If that email exists, a reset link is on its way.');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch {
      // Don't leak which field was wrong.
      setError('Incorrect email or password.');
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={handleSubmit}>
        <img src={BRAND.logoSrc} alt={BRAND.name} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        <h1>Welcome back</h1>
        <p className="sub">Sign in to the {BRAND.workspaceLabel}.</p>

        {error && (
          <div className="form-error" role="alert">
            {error}
          </div>
        )}

        <input
          className="input"
          type="email"
          autoComplete="email"
          placeholder={BRAND.emailExample}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          className="input"
          type="password"
          autoComplete="current-password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button
          type="submit"
          className="btn btn-primary"
          style={{ width: '100%', height: 'var(--btn-height-lg)' }}
          disabled={busy}
        >
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        {resetMsg && <div className="form-success" role="status" style={{ marginTop: 8 }}>{resetMsg}</div>}
        <button type="button" onClick={handleForgot} style={{ background: 'none', border: 'none', color: 'var(--color-brand)', cursor: 'pointer', fontSize: 'var(--text-small)', marginTop: 8 }}>
          Forgot password?
        </button>
      </form>
    </div>
  );
}
